module.exports = __webpack_public_path__ + "img/luckDraw.90674612.png";